import React from "react";
import { STAGE_STYLES, TYPE_STYLES, VERIFY_STYLES } from "@/lib/rights";

export const StageBadge = ({ stage, label, testId }) => (
  <span data-testid={testId}
        className={`inline-flex items-center px-2 py-0.5 rounded-full border text-[11px] font-semibold whitespace-nowrap ${STAGE_STYLES[stage] || ""}`}>
    {label || stage}
  </span>
);

export const TypeBadge = ({ type, label, testId }) => (
  <span data-testid={testId}
        className={`inline-flex items-center px-2 py-0.5 rounded text-[10px] font-bold uppercase tracking-wide whitespace-nowrap ${TYPE_STYLES[type] || "bg-slate-200"}`}>
    {label || type}
  </span>
);

export const VerifyBadge = ({ status, testId }) => (
  <span data-testid={testId}
        className={`inline-flex items-center px-2 py-0.5 rounded-full border text-[10px] font-semibold uppercase tracking-wide ${VERIFY_STYLES[status] || ""}`}>
    {status === "VERIFIED" ? "ID verified" : status === "FAILED" ? "ID failed" : "ID pending"}
  </span>
);

export const DueLabel = ({ r, testId }) => {
  if (r.status === "CLOSED") {
    return (
      <span data-testid={testId} className={`text-xs font-mono ${r.closed_on_time ? "text-emerald-700" : "text-red-600"}`}>
        {r.closed_on_time ? "Closed on time" : "Closed late"}
      </span>
    );
  }
  const d = r.days_remaining;
  const cls = r.is_overdue ? "text-red-600 font-semibold" : d <= 7 ? "text-amber-700 font-semibold" : "text-slate-600";
  return (
    <span data-testid={testId} className={`text-xs font-mono ${cls}`}>
      {r.is_overdue ? `${Math.abs(d)}d overdue` : `${d}d left`}
    </span>
  );
};

export const Panel = ({ title, eyebrow, actions, children, testId, className = "" }) => (
  <section className={`bg-white border border-slate-200 rounded-xl ${className}`} data-testid={testId}>
    {(title || actions) && (
      <header className="flex items-start justify-between gap-3 px-5 pt-4 pb-3 border-b border-slate-100">
        <div>
          {eyebrow && <div className="text-[10px] font-mono uppercase tracking-wider text-slate-400">{eyebrow}</div>}
          <h2 className="text-sm font-semibold text-[#003366]">{title}</h2>
        </div>
        {actions && <div className="flex items-center gap-2 flex-wrap">{actions}</div>}
      </header>
    )}
    <div className="p-5">{children}</div>
  </section>
);
